import React, { useEffect } from 'react';
import CountButton from '../../Components/CountButton/CountButton';
import { Button, Textarea } from '../../Components/StyledComponents';
import './WaitingSetting.scss';
import {cloneDeep} from 'lodash-es';

const WaitingSetting = ({ info, patchInfo }) => {
    const [ avgTime, setAvgTime ] = React.useState(20)//평균 대기시간
    const [ isTime, setIsTime ] = React.useState(false)//대기시간 노출 여부
    const [ isAutoCall, setIsAutoCall ] = React.useState(false)//자동 호출
    const [ maxCount, setMaxCount ] = React.useState(10)//최대 대기 팀
    const [ intro, setIntro ] = React.useState('')//매장 웨이팅 안내
    const [ isChair, setIsChair ] = React.useState(false)//유아용 의자 보유 여부

    useEffect(() => {
        if(typeof info !== 'undefined' && Object.keys(info).length > 0 ){
            setAvgTime(info.AvgTime);
            setIsTime(info.ShowTime);
            setIsAutoCall(info.AutoCall);
            setMaxCount(info.MaxTeam);
            setIsChair(info.BabyChair);
            setIntro(info.Notice);
        }
    },[])

    //웨이팅 정보 수정    
    const patch = () => {
        patchInfo({
            BabyChair : isChair,
            ShowTime : isTime,
            AutoCall : isAutoCall,
            AvgTime : avgTime,
            MaxTeam : maxCount,
            Notice : intro
        })
    }

    return (
        <div className='point-rate'>
            <div className='row between'>
                <p className='modal-title'>유아용 의자 여부</p>
                <div className='row'>
                    <button className={`${ isChair ? 'selected-btn' : 'unselected-btn'}`} style={{ marginRight : 16 }} onClick={() => setIsChair(true)}>
                        <div className='row' style={{ justifyContent : 'center' }}>
                            {
                                isChair ?
                                <img src={require('../../aseets/icons/check.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                                :
                                <img src={require('../../aseets/icons/check_white.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                            }
                            보유
                        </div>
                    </button>

                    <button className={`${ !isChair ? 'selected-btn' : 'unselected-btn'}`} onClick={() => setIsChair(false)}>
                        <div className='row' style={{ justifyContent : 'center' }}>
                            {
                                isChair ?
                                <img src={require('../../aseets/icons/close.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                                :
                                <img src={require('../../aseets/icons/close_white.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                            }
                            미보유
                        </div>
                    </button>
                </div>
            </div>
            <div className='divider' />
            <div className='row between'>
                <p className='modal-title'>대기시간 노출</p>
                <div className='row'>
                    <button className={`${ isTime ? 'selected-btn' : 'unselected-btn'}`} style={{ marginRight : 16 }} onClick={() => setIsTime(true)}>
                        <div className='row' style={{ justifyContent : 'center' }}>
                            {
                                isTime ?
                                <img src={require('../../aseets/icons/check.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                                :
                                <img src={require('../../aseets/icons/check_white.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                            }
                            사용
                        </div>
                    </button>

                    <button className={`${ !isTime ? 'selected-btn' : 'unselected-btn'}`} onClick={() => setIsTime(false)}>
                        <div className='row' style={{ justifyContent : 'center' }}>
                            {
                                isTime ?
                                <img src={require('../../aseets/icons/close.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                                :
                                <img src={require('../../aseets/icons/close_white.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                            }
                            미사용
                        </div>
                    </button>
                </div>
            </div>
            {/* <div className='divider' />
            <div className='row between'>
                <p className='modal-title'>자동호출</p>
                <div className='row'>
                    <button className={`${ isAutoCall ? 'selected-btn' : 'unselected-btn'}`} style={{ marginRight : 16 }} onClick={() => setIsAutoCall(true)}>
                        <div className='row' style={{ justifyContent : 'center' }}>
                            {
                                isAutoCall ?
                                <img src={require('../../aseets/icons/check.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                                :
                                <img src={require('../../aseets/icons/check_white.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                            }
                            사용
                        </div>
                    </button>

                    <button className={`${ !isAutoCall ? 'selected-btn' : 'unselected-btn'}`} onClick={() => setIsAutoCall(false)}>
                        <div className='row' style={{ justifyContent : 'center' }}>
                            {
                                isAutoCall ?
                                <img src={require('../../aseets/icons/close.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                                :
                                <img src={require('../../aseets/icons/close_white.svg').default} style={{ width : 24, height : 24, marginRight : 8 }}/>
                            }
                            미사용
                        </div>
                    </button>
                </div>
            </div> */}

            <div className='divider' />
            <div className='row'>
                <p className='modal-title'>평균 대기 시간</p>
                <CountButton value={avgTime} step={10} setValue={(val) => setAvgTime(val)} min={0} max={360}/>
            </div>

            <div className='divider' />
            <div className='row'>
                <p className='modal-title'>최대 대기가능팀</p>
                <CountButton value={maxCount} setValue={(val) => setMaxCount(val)} min={5} max={50}/>
            </div>
            <div className='divider' />

            <div className='row' style={{ alignItems : 'flex-start', marginTop : 16 }}>
                <p className='label'>공지사항</p>
                <Textarea
                    value={intro}
                    onChange={(e) => setIntro(e.target.value)}
                    style={{ width : 347, height : 173 }}
                    placeholder="매장에 대한 공지사항을 입력해주세요."
                />
            </div>

            <div className='btn-row'>
                <Button variant="main" className='save-btn' fontSize={16} onClick={patch}>
                    저장하기
                </Button>
            </div>
        </div>
    )
}

export default WaitingSetting;